import PrefetchLink from "@/components/PrefetchLink";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import logoAcesso from "@/assets/logo-acesso-white.png";

const Footer = () => (
  <footer className="bg-primary text-primary-foreground">
    <div className="container mx-auto px-4 py-12">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img src={logoAcesso} alt="Acesso Sistemas de Segurança" className="h-8" width={155} height={32} sizes="155px" decoding="async" />
          </div>
          <p className="text-primary-foreground/70 text-sm leading-relaxed">
            Segurança inteligente para condomínios em Goiânia e região. Tecnologia de ponta com atendimento humanizado.
          </p>
        </div>

        {/* Links */}
        <div>
          <h3 className="font-semibold mb-4 text-sm uppercase tracking-wider">Navegação</h3>
          <ul className="space-y-2 text-sm text-primary-foreground/70">
            <li><PrefetchLink to="/" className="hover:text-accent transition-colors">Home</PrefetchLink></li>
            <li><PrefetchLink to="/empresa" className="hover:text-accent transition-colors">A Empresa</PrefetchLink></li>
            <li><PrefetchLink to="/solucoes" className="hover:text-accent transition-colors">Soluções</PrefetchLink></li>
            <li><PrefetchLink to="/atuacao" className="hover:text-accent transition-colors">Atuação</PrefetchLink></li>
            <li><PrefetchLink to="/aplicativo" className="hover:text-accent transition-colors">Aplicativo</PrefetchLink></li>
            <li><PrefetchLink to="/faq" className="hover:text-accent transition-colors">FAQ</PrefetchLink></li>
            <li><PrefetchLink to="/contato" className="hover:text-accent transition-colors">Contato</PrefetchLink></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-semibold mb-4 text-sm uppercase tracking-wider">Contato</h3>
          <ul className="space-y-3 text-sm text-primary-foreground/70">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-accent" /> 0800 940 2501</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent" /> contato@acesso.srv.br</li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-accent mt-0.5" /> Av. T-3, 2115 - Qd. 93 Lt. 18 - St. Bueno, Goiânia - GO, 74210-245</li>
          </ul>
        </div>

        {/* Social */}
        <div>
          <h3 className="font-semibold mb-4 text-sm uppercase tracking-wider">Siga a Acesso</h3>
          <ul className="space-y-3 text-sm text-primary-foreground/70">
            <li><a href="https://www.facebook.com/acessogo/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-accent transition-colors"><Facebook className="h-4 w-4 text-accent" /> Facebook</a></li>
            <li><a href="https://www.instagram.com/acesso.srv/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-accent transition-colors"><Instagram className="h-4 w-4 text-accent" /> Instagram</a></li>
            <li><a href="https://br.linkedin.com/company/acesso-sistemas-de-seguran%C3%A7a" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-accent transition-colors"><Linkedin className="h-4 w-4 text-accent" /> LinkedIn</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-foreground/10 mt-10 pt-6 text-center text-xs text-primary-foreground/70">
        <p className="mb-2">Portaria Remota em Goiânia · Segurança Condominial em Goiânia · Monitoramento 24h Goiás</p>
        <p>© {new Date().getFullYear()} Acesso Sistemas de Segurança. Todos os direitos reservados.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
